import { render, staticRenderFns } from "./cursos-detalles-resumen-preguntas-pregunta-opcion.vue?vue&type=template&id=73e31cc6&scoped=true&"
import script from "./cursos-detalles-resumen-preguntas-pregunta-opcion.vue?vue&type=script&lang=ts&"
export * from "./cursos-detalles-resumen-preguntas-pregunta-opcion.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-detalles-resumen-preguntas-pregunta-opcion.vue?vue&type=style&index=0&id=73e31cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e31cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow,VSpacer})
